import React from "react";
import { LegalPage } from "@/pages/PrivacyPolicy";

export default function TermsConditions() {
  return <LegalPage pageKey="terms" />;
}
